import AbsoluteSpinner from './AbsoluteSpinner';
import SimpleSpinner from './SimpleSpinner';

export const Spinners = {
  SIMPLE: SimpleSpinner,
  ABSOLUTE: AbsoluteSpinner,
};
